import { IconButton, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { RefreshIcon } from "../svgIcon/RefreshIcon";
import { DownloadIcon } from "../svgIcon/DownloadIcon";
import { ArrowDownSquare, ArrowUpSquare } from "react-iconly";
import { ScrollListIcon } from "../svgIcon/ScrollListIcon";
import { UnSuccessIcon } from "../svgIcon/UnSuccessIcon";

const AVCTableHeader = ({
  title,
  handleDownloadData,
  handleRefreshData,
  handleExtendTable,
  handleMinimizeTable,
  handleTableHeight,
  isExtended,
  isTableFixed,
  toggleTableSize,
  toggleTableHeight,
}) => {
  const theme = useTheme();
  return (
    <Stack py={0.5} px={3} bgcolor="primary.main" sx={{ borderStartStartRadius: 24, borderStartEndRadius: 24 }}>
      <Stack justifyContent="space-between" direction="row" alignItems="center">
        <Typography variant="subtitle1" color="primary.contrastText">
          {title}
        </Typography>
        <Stack direction="row">
          {handleExtendTable &&
            handleMinimizeTable &&
            (isExtended ? (
              <Tooltip title="پیمایش, غیرفعال" placement="bottom">
                <IconButton onClick={toggleTableSize}>
                  <UnSuccessIcon color={theme.palette.common.white} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="پیمایش, فعال" placement="bottom">
                <IconButton onClick={toggleTableSize}>
                  <ScrollListIcon color={theme.palette.common.white} />
                </IconButton>
              </Tooltip>
            ))}
          {handleTableHeight &&
            (isTableFixed ? (
              <Tooltip title="حالت بسته" placement="bottom">
                <IconButton onClick={toggleTableHeight}>
                  <ArrowUpSquare color={theme.palette.common.white} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="حالت باز" placement="bottom">
                <IconButton onClick={toggleTableHeight}>
                  <ArrowDownSquare color={theme.palette.common.white} />
                </IconButton>
              </Tooltip>
            ))}

          {handleRefreshData && (
            <Tooltip title="بارگذاری مجدد" placement="bottom">
              <IconButton
                onClick={() => {
                  handleRefreshData();
                }}
              >
                <RefreshIcon color={theme.palette.primary.contrastText} />
              </IconButton>
            </Tooltip>
          )}
          {handleDownloadData && (
            <Tooltip title="دریافت خروجی" placement="bottom">
              <IconButton
                onClick={() => {
                  handleDownloadData();
                }}
              >
                <DownloadIcon color={theme.palette.common.white} />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AVCTableHeader;
